<template>
  <div id="app">
    <h1 class="title">Vue-progressbar</h1>
    <h3 class="sub title">A robust progress bar for VueJS 2.0</h3>
    <img src="./assets/logo.png">
    <hello></hello>
  </div>
</template>

<script>
import Hello from './components/Hello'

export default {
  name: 'app',
  components: {
    Hello
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
.title {
  color: #fff;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sub {
  opacity: 0.7;
}
#app {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// App.vue?7dec2ffd